// extracted by mini-css-extract-plugin
export var cardContainer = "styles-module--cardContainer--d1e09";
export var categoryVariant = "styles-module--categoryVariant--0eeb8";
export var heroCardContainer = "styles-module--heroCardContainer--93c30";
export var latestPostsContainer = "styles-module--latestPostsContainer--e3d31";
export var postGrid = "styles-module--postGrid--53b6a";
export var title = "styles-module--title--94564";